<div class="tw-bg-gradient-teal-to-white tw-flex tw-flex-col tw-gap-4 tw-pl-4 tw-pt-4 tw-pb-6">
  <div class="tw-flex tw-items-center tw-gap-2 tw-pr-4" (click)="navigateToShop()">
    @if (regimenImage) {
      <img [src]="regimenImage" alt="" class="tw-flex-none tw-h-10 tw-w-10 tw-rounded-full tw-object-cover" />
    } @else {
      <div class="tw-flex-none tw-h-10 tw-w-10 tw-rounded-full tw-bg-gray-700"></div>
    }
    <div class="tw-flex-1">
      <div class="tw-flex tw-items-center tw-justify-between">
        <p class="tw-font-lexend tw-text-500 tw-leading-[21px] tw-text-gray-800" style="font-weight: 700!important;" i18n="@@notReadyForFullKit">
          Not ready for full kit?
        </p>
        <cs-icon class="tw-h-[18px] tw-w-[18px]" [iconName]="'chevron_right_teal_rounded'"></cs-icon>
      </div>
      <p class="tw-font-body tw-text-200 tw-text-gray-500 tw-opacity-80 tw-pr-6" i18n="@@startSmallWithFewProducts">Start small with few products from your kit</p>
    </div>
  </div>

  <div class="tw-flex tw-gap-4 tw-overflow-x-auto tw-pr-4">
    @for (product of products; track product.objectId) {
      <app-product-jumbo
        [product]="product"
        [productInCart]="productsInCart[product.objectId]"
        [isLocked]="lockedProductIds.includes(product.objectId)"
        (addToCart)="onAddToCart($event)"
        (reomveFromCart)="onRemoveFromCart($event)"
        (gotoProduct)="onGotoProduct($event)"></app-product-jumbo>
    }
  </div>
</div>
